/* Street Garms SG-045 — mobile sticky Add-to-Cart composition experiment.
 * Default/no parameter = compact price + size/condition summary (summary).
 * Preview/test URLs on a product page:
 *   ?sg_sticky=control
 *   ?sg_sticky=summary
 *   ?sg_sticky=auto   (50/50 session-level assignment)
 *
 * The experiment is visual/trackable only on mobile <= 767px.
 * Tracking hooks use dataLayer + CustomEvent only and make no third-party requests.
 */
(function () {
  'use strict';

  var EXPERIMENT = 'SG-045';
  var PARAM = 'sg_sticky';
  var SESSION_KEY = 'sg045StickyVariant';
  var VALID = ['control', 'summary'];
  var exposureSent = false;
  var stickyBound = false;

  function normalise(value) {
    value = String(value || '').toLowerCase().trim().replace(/-/g, '_');
    if (value === 'a' || value === 'control' || value === 'current' || value === 'minimal') return 'control';
    if (value === 'b' || value === 'summary' || value === 'micro_summary' || value === 'compact') return 'summary';
    if (value === 'auto' || value === 'random') return 'auto';
    return '';
  }

  function isMobile() {
    return window.matchMedia ? window.matchMedia('(max-width: 767px)').matches : window.innerWidth <= 767;
  }

  function randomVariant() {
    return Math.random() < 0.5 ? 'control' : 'summary';
  }

  function getVariant() {
    var requested = '';
    try { requested = normalise(new URL(window.location.href).searchParams.get(PARAM)); } catch (e) {}

    if (requested === 'auto') {
      try {
        var stored = normalise(window.sessionStorage.getItem(SESSION_KEY));
        if (VALID.indexOf(stored) !== -1) return stored;
        var assigned = randomVariant();
        window.sessionStorage.setItem(SESSION_KEY, assigned);
        return assigned;
      } catch (e) {
        return randomVariant();
      }
    }

    if (VALID.indexOf(requested) !== -1) {
      try { window.sessionStorage.setItem(SESSION_KEY, requested); } catch (e) {}
      return requested;
    }

    // SG-045.2 approved default: compact price + size/condition summary.
    // The original minimal bar remains available via ?sg_sticky=control for the future experiment.
    return 'summary';
  }

  function push(eventName, variant, extra) {
    var payload = {
      event: eventName,
      sg_experiment_id: EXPERIMENT,
      sg_sticky_variant: variant
    };
    if (extra) Object.keys(extra).forEach(function (key) { payload[key] = extra[key]; });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function dispatch(eventName, variant, extra) {
    try {
      window.dispatchEvent(new CustomEvent(eventName, {
        detail: Object.assign({ experiment: EXPERIMENT, variant: variant }, extra || {})
      }));
    } catch (e) {}
  }

  function productContext() {
    var sticky = document.querySelector('[data-sticky-addtocart]');
    var button = sticky && sticky.querySelector('[data-action-atc]');
    return {
      product_path: window.location.pathname || '',
      variant_id: button ? (button.getAttribute('data-variant-id') || '') : '',
      viewport_width: window.innerWidth || 0
    };
  }

  function scrollDepth() {
    var doc = document.documentElement;
    var body = document.body;
    var y = window.scrollY || window.pageYOffset || 0;
    var height = Math.max(
      body ? body.scrollHeight : 0,
      doc ? doc.scrollHeight : 0
    ) - (window.innerHeight || 0);
    if (height <= 0) return 0;
    return Math.max(0, Math.min(100, Math.round((y / height) * 100)));
  }

  function syncSummaryPrice(sticky) {
    var source = sticky.querySelector('[data-sticky-price]');
    var target = sticky.querySelector('[data-sg045-summary-price]');
    if (!source || !target) return;
    target.innerHTML = source.innerHTML;

    try {
      var observer = new MutationObserver(function () {
        target.innerHTML = source.innerHTML;
      });
      observer.observe(source, { childList: true, subtree: true, characterData: true });
    } catch (e) {}
  }

  function sendExposureIfVisible(sticky, variant) {
    if (exposureSent || !isMobile() || !sticky.classList.contains('is--shown')) return;
    exposureSent = true;
    var extra = productContext();
    extra.sg_scroll_depth_pct = scrollDepth();
    push('sg045_sticky_exposure', variant, extra);
    dispatch('sg:sticky-exposure', variant, extra);
  }

  function bindSticky(sticky, variant) {
    if (!sticky || stickyBound) return;
    stickyBound = true;
    sticky.setAttribute('data-sg045-variant', variant);
    syncSummaryPrice(sticky);

    sticky.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-action-atc]');
      if (!button || !sticky.contains(button) || !isMobile()) return;
      var extra = productContext();
      extra.sg_scroll_depth_pct = scrollDepth();
      push('sg045_sticky_atc_click', variant, extra);
      dispatch('sg:sticky-atc-click', variant, extra);
    }, true);

    try {
      var classObserver = new MutationObserver(function () {
        sendExposureIfVisible(sticky, variant);
      });
      classObserver.observe(sticky, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {}

    sendExposureIfVisible(sticky, variant);
  }

  function waitForSticky(variant) {
    var sticky = document.querySelector('[data-sticky-addtocart]');
    if (sticky) {
      bindSticky(sticky, variant);
      return;
    }

    try {
      var observer = new MutationObserver(function () {
        var found = document.querySelector('[data-sticky-addtocart]');
        if (!found) return;
        observer.disconnect();
        bindSticky(found, variant);
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }

  function bindMainPdpAtc(variant) {
    document.addEventListener('submit', function (event) {
      if (!isMobile()) return;
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      var extra = productContext();
      extra.sg_scroll_depth_pct = scrollDepth();
      push('sg045_main_pdp_add_to_cart', variant, extra);
      dispatch('sg:main-pdp-add-to-cart', variant, extra);
    }, true);
  }

  function apply() {
    var variant = getVariant();
    document.documentElement.setAttribute('data-sg-sticky-experiment', EXPERIMENT);
    document.documentElement.setAttribute('data-sg-sticky-variant', variant);
    waitForSticky(variant);
    bindMainPdpAtc(variant);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }
})();
